import axios from 'axios';
import { ACCESS_TOKEN } from '../../utils/constants';
import { getLocalStorage } from '../../utils/localStorage';

const fetch = async ({ url, method, data, params, headers, token }) => axios({
    url,
    method,
    data,
    params,
    headers: {
      ...headers,
      Authorization: `Bearer ${token}`,
    },
  });
export const axiosBaseQuery = ({ baseUrl } = { baseUrl: '' }) => async ({ url, method, data, params, headers }) => {
       const token = getLocalStorage(ACCESS_TOKEN);

    try {
      const result = await fetch({
        url: baseUrl + url,
        method,
        data,
        params,
        headers: {
          ...headers,
          Authorization: `Bearer ${token}`,
        },
        token
      });
      return { data: result.data };
    } catch (error) {
      const err = error; 
      const errorMessage = err.response?.data || err.message;
         if (
        err.response &&
        err.response?.status === 401 &&
        !window.location.href.startsWith(`${window.location.origin}/login`)
      ) {
        window.open(`${window.location.origin}/login`, '_self');
      }
      return {
        error: {
          status: err.response?.status,
          data: (errorMessage).message ?? errorMessage,
        },
      };
    }
  };

